<div
   class="ui-g-12 ui-lg-12 text-right"
   style="float:unset;">
    <button
      pButton type="button"
      class="k-generic-btn"
      icon="fa fa-angle-left"
      iconPos="left"
      (click)="goBack()"
      label="{{ 'common.back' | translate }}">
    </button>
</div>

<app-kontable
  #table
  *ngIf="userStoreAndSalesNetworks"
  [source]="userStoreAndSalesNetworks"
  title="{{ 'common.storesAndSalesNetworksTitle' | translate }}"
  [columns]="[
    'store_name',
    'sales_network_name',
    'division_name',
    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter }
  ]"
  [titles]="[
    'common.store_title',
    'salesNetworkList.saleNetwork',
    'common.division'
  ]"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [showGlobalFilter]="false"
  [showInfoButton]="false"
  (onAdd)="openDialog($event)"
  (onEdit)="openDialog($event)"
  (onRemove)="deleteElement($event)"
>

  <ng-template #stateTemplate data-testid="stateTemplate" let-row>
    <span *ngIf="row.flg_state && row.flg_state !== '0'" class="fa fa-trash-o" title="state"></span>
  </ng-template>

  <ng-template #stateFilter data-testid="stateFilter" let-col>
    <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
  </ng-template>

</app-kontable>

<p-dialog
  *ngIf="showDialog"
  [(visible)]="showDialog"
  [modal]="true"
  [minWidth]="500"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()"
  [header]="dialogTitle">

  <form
    *ngIf="fields && form"
    id="user-stores-form"
    [ngClass]="{'invalid-submit': invalidSubmit}"
    style="padding-left: 20px;"
    [formGroup]="form"
    (ngSubmit)="saveOrUpdate()"
    class="bottom-10-margin" 
    RestrictFocus>
    <div class="ui-grid ui-grid-responsive ui-fluid">

      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4">
          <label [ngClass]="{'required': !fields.store_id.nullable}">
            {{ fields.store_id.keyName }}
          </label>
        </div>
        <div class="ui-grid-col-8">
            <p-autoComplete
              [style]="{'width':'100%'}"
              formControlName="store_id"
              [(ngModel)]="selectedStore"
              [suggestions]="stores"
              (completeMethod)="getFilteredStores($event)"
              [dropdown]="true"
              (onSelect)="storeSelected($event)"
              [disabled]="storeFieldDisabled"
              field="label">
            </p-autoComplete>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.store_id"></app-validation-msg>
        </div>
      </div>

      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4">
          <label [ngClass]="{'required': !fields.division_sales_network_id.nullable}">
            {{ fields.division_sales_network_id.keyName }} - {{ 'common.division' | translate }}
          </label>
        </div>
        <div class="ui-grid-col-8">
            <p-dropdown
              formControlName="division_sales_network_id"
              [options]="salesNetworks"
              filter="true"
              [style]="{ 'width': '100%'}"
              [disabled]="salesNetworkFieldDisabled"
              (onChange)="salesNetworkSelected($event)"
            ></p-dropdown>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.division_sales_network_id"></app-validation-msg>
            <span class="input-error-notification" *ngIf="formError">{{ 'common.storeOrSalesNetworkError' | translate }}</span>
        </div>
      </div>

    </div>

    <p-footer>
      <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
          <button
            pButton
            type="submit"
            class="k-generic-btn"
            label="{{ 'common.save' | translate }}"
          ></button>
      </div>
    </p-footer>

  </form>

</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/user-stores-and-sales-networks/user-stores-and-sales-networks.component.html